// Define an interface for the tag data
export interface IPortals {
  author: string;
  creationDate: string;
  description: string;
  extension: string; // Number of tagged entities
  file: string;
  fileType: string;
  id: number;
  publisher: string;
  size: string;
  status: string;
  uploadStatus: any;
}

export interface IPortalsData {
  portals: IPortals[];
  totalItems: number;
  totalPages: number;
}

export interface IfetchPortals {
  data: IPortalsData;
  message: string;
  stateIs: "Idle" | "Pending" | "Error";
}

// Create an initial state object for tags
const initialPortalsState: IfetchPortals = {
  data: {
    portals: [],
    totalItems: 0,
    totalPages: 1,
  },
  message: "",
  stateIs: "Idle",
};

export default initialPortalsState;
